import { createContext } from 'react';

import type { ContentCtx } from './Content';

export const ContentContext = createContext<ContentCtx>({ closeTab: () => {}, routes: [] });

export default {};
